import React from 'react';
import { Button, Container, Row, Col } from 'react-bootstrap';
import './HeroSection.css';

function HeroSection() {
  return (
    <div className="hero-section">
      <div className="hero-overlay-content">
        <Container>
          <Row className="align-items-center">
            <Col md={6} className="hero-content text-md-start text-center mb-4 mb-md-0">
              <h1 className="hero-heading">Empowering Schools to Become Local Icons</h1>
              <p className="hero-subheading">
                Counselling, Branding & Academic Support Tailored for Local Schools.
              </p>
              <div className="hero-buttons d-flex justify-content-center justify-content-md-start flex-wrap">
                {/* ✅ Wrap Button with <a> for call action */}
                <a href="tel:+919910292689">
                  <Button variant="primary" className="me-md-3 mb-3 mb-md-0">
                    Request A CallBack
                  </Button>
                </a>
                {/* <Button variant="secondary" className="talktous">Talk to Us</Button> */}
              </div>
            </Col>
            <Col md={6} className="text-center">
              <img src="/Images/hero-image41.png" alt="Students" className="hero-img img-fluid" />
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default HeroSection;
